// @theme component
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { formatTimeFromSeconds } from '@core/js/hooks/useFormatter/helpers';

import style from './index.scss';

type BlockingTimerProps = {
    timerDurationMs: number
    timerEndCallback?: () => void
}

const BlockingTimer = React.memo(({ timerDurationMs, timerEndCallback }: BlockingTimerProps) => {
    const [time, setTime] = useState(Math.floor(timerDurationMs / 1000));
    const interval = useRef<number>(0);

    const timerTick = useCallback(() => {
        setTime((currentTime: number) => {
            if (currentTime <= 0) {
                window.clearInterval(interval.current);
                return 0;
            }

            return currentTime - 1;
        });
    }, []);

    useEffect(() => {
        if (time > 0) {
            return;
        }

        timerEndCallback?.();
    }, [time, timerEndCallback]);

    useEffect(() => {
        interval.current = window.setInterval(timerTick, 1000);

        return () => {
            window.clearInterval(interval.current);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <span className={style.timerValue}> {formatTimeFromSeconds(time)}</span>
    );
});

export default BlockingTimer;
